export interface NavigationItem {
  name: string;
  href: string;
  permission?: string | string[] | null;
  icon?: string;
}

export const getInternalNavigation = (): NavigationItem[] => [
  { name: 'Dashboard', href: '/dashboard', permission: null, icon: 'dashboard' },
  { name: 'Pengguna', href: '/users', permission: 'users.read', icon: 'users' },
  { name: 'Partner', href: '/partners', permission: 'partners.read', icon: 'partners' },
  { name: 'Proyek', href: '/projects', permission: 'projects.read', icon: 'projects' },
];

export const getPartnerNavigation = (): NavigationItem[] => [
  { name: 'Dashboard', href: '/partner/dashboard', permission: null, icon: 'dashboard' },
  { name: 'Proyek Saya', href: '/partner/projects', permission: null, icon: 'projects' },
];

export type UserType = 'internal' | 'partner';

export const getNavigationForUserType = (userType: UserType): NavigationItem[] => {
  switch (userType) {
    case 'partner':
      return getPartnerNavigation();
    case 'internal':
    default:
      return getInternalNavigation();
  }
};